<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import router from '@/router';
import Product from '@/models/product';
import { getProductForCooking } from '@/composables/itemWorker';
import { setBottomButton, hideBottomButton, setBackButton, hideBackButton } from '@/tools/setTelegramButtons';
import { setHaptic } from '@/tools/setTelegramHaptick';
import PieceItem from '@/components/mobile/telegram/work_pieces/PieceItem.vue';
import { useStore } from "vuex";

const mainButtonPressed = () => {
  setHaptic();
  router.push(`/cart_pieces?point_id=store_warehouse`);
}

const store = useStore();
const products = ref<Product[] | null>(null);
const respIsResieved = ref<boolean>(false);

async function getProductsForPieces() {
  products.value = await getProductForCooking();
  respIsResieved.value = true;
  setBottomButton('Корзина', '31B545', 'FFFFFF', mainButtonPressed)
}

onMounted(async () => {
  if (store.getters.USER?.role !== 'zagotovshik') {
    setBackButton();
  }
  await getProductsForPieces();
})

onUnmounted(() => {
  hideBackButton();
  hideBottomButton();
});

</script>

<template>

  <div class="shop-wrapper">
    <div class="label-section">
      <p class="label-settings">Заготовки</p>
    </div>
    <div class="shop-items">
      <PieceItem v-for="product in products" 
        :product="product"
        :respIsResieved="respIsResieved"
      />
    </div>
  </div>

</template>

<style scoped>

.shop-items{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  gap: 5px;
  margin-top: 20px;
}

.label-section{
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
}

.shop-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

</style>
 